var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
		'exceed-allocation-badge',
		!_vm._get(_vm.allotmentSettings, 'isBoundToBudget') ? 'exceed-allocation-badge--success' : 'exceed-allocation-badge--danger',
	]},[_vm._v(" "+_vm._s(!_vm._get(_vm.allotmentSettings, 'isBoundToBudget') ? 'Can Exceed' : 'Strict')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }